gsap.registerPlugin(ScrollTrigger);

window.addEventListener("DOMContentLoaded", () => {
  createGsapActions();
});

const createGsapActions = () => {
  gsap.to('#eb-header', {
    scrollTrigger: {
      trigger: '#eb-contents',
      // markers: true,
      start: 'top top',
      end: 'bottom bottom',
      onEnter: self => {
        toggleHeader();
      },
      onLeaveBack: self => {
        toggleHeader();
      }
    }
  });

  const packageVideoElm = document.querySelector('#js-packageVideo');
  if ( packageVideoElm !== null ) {
    setVideoActions();
  }

  // フェードインアニメーション
  const fadeInContents = gsap.utils.toArray('.js-fadeIn');
  fadeInContents.forEach((target) => {
    gsap.to(target, {
      scrollTrigger: {
        trigger: target,
        // markers: true,
        start: "top 80%",
        end: "bottom 80%",
        // scrub: true
        onEnter: () => {
          if ( !target.classList.contains('is-visible') ) {
            target.classList.add('is-visible');
          }
        }
      }
    });
  });

  const slideInContents = gsap.utils.toArray('.js-slideIn');
  slideInContents.forEach((target) => {
    gsap.to(target, {
      scrollTrigger: {
        trigger: target,
        // markers: true,
        start: "top 80%",
        end: "bottom 80%",
        // scrub: true
        onEnter: () => {
          if ( !target.classList.contains('is-visible') ) {
            target.classList.add('is-visible');
          }
        }
      }
    });
  });

  gsap.utils.toArray('.js-parallax').forEach(elem => {
    let moveY;
    if ( window.innerWidth <= 700 ) {
      moveY = elem.offsetHeight * 0.1;
    } else {
      moveY = elem.offsetHeight * 0.1;
    }
    gsap.fromTo(elem, {
      y: moveY * -1,
    }, {
      y: moveY,
      ease: 'none',
      scrollTrigger: {
        trigger: elem,
        start: 'top bottom',
        end: 'bottom top',
        scrub: true,
        // markers: true,
      }
    })
  });

};

const toggleHeader = () => {
  const header = document.querySelector('#eb-header');
  header.classList.toggle('is-fixed');
};

const setVideoActions = () => {
  gsap.to('#js-packageVideo', {
    scrollTrigger: {
      trigger: '#js-packageVideo',
      // markers: true,
      start: 'center bottom',
      onEnter: self => {
        window.requestAnimationFrame(function(time) {
          self.trigger.play();
        });
      },
    },
  });

  gsap.to('#js-packageVideo', {
    scrollTrigger: {
      trigger: '#js-packageVideo',
      // markers: true,
      start: 'top bottom',
      onLeaveBack: self => {
        self.trigger.currentTime = 0;
      },
    },
  });
};
